// French strings of the automations panel, the routine editor and the n8n trigger editor
// (registered at module load; see docs/UI-CONTRACT.md §7).
import { registerStrings } from '../../i18n/fr.js';

registerStrings({
  'auto.eyebrow': 'MAECK OFFICE',
  'auto.subtitle': 'Ce que les agents font seuls : à heure fixe (routines) ou quand n8n les appelle (déclencheurs).',
  'auto.search': 'Rechercher…',
  'auto.searchLabel': 'Rechercher',
  'auto.floorAll': 'Tous les étages',
  'auto.floorLabel': 'Étage',
  'auto.agentAll': 'Tous les agents',
  'auto.agentLabel': 'Agent',
  'auto.groupLabel': 'Regrouper les routines',
  'auto.group.dept': 'Par service',
  'auto.group.agent': 'Par agent',
  'auto.group.agentLink': 'Ouvrir les routines de {name}',
  'auto.loading': 'Chargement…',
  'auto.retry': 'Réessayer',
  'auto.unavailable': 'Cette partie n’est pas encore disponible sur ce serveur.',
  'auto.noResults': 'Aucun résultat pour ces filtres.',
  'auto.calendar': 'Voir le calendrier',
  'auto.more': 'Plus d’actions',
  'auto.unknownAgent': 'Agent inconnu',
  'auto.never': 'jamais',
  'auto.none': '—',

  // Autonomy and output format
  'auto.autonomy': 'Validation',
  'auto.autonomy.inherit': 'Comme l’agent',
  'auto.autonomy.approve': 'Je valide avant d’agir',
  'auto.autonomy.auto': 'Agit seul',
  'auto.autonomyHelp.inherit': 'Suit le réglage de l’agent, aujourd’hui : {agent}. Changer l’agent change donc cette routine.',
  'auto.autonomyHelp.inheritUnknown': 'Suit le réglage de l’agent choisi (« je valide avant d’agir » ou « agit seul »).',
  'auto.autonomyHelp.approve': 'L’agent prépare un brouillon qui attend dans « À valider » : rien n’est envoyé, publié ni modifié sans votre accord.',
  'auto.autonomyHelp.auto': 'L’agent agit seul avec ses outils (en écriture) et termine la tâche, sans vous attendre. À réserver aux actions sans risque.',
  'auto.agentAutonomy.approve': '« je valide avant d’agir »',
  'auto.agentAutonomy.auto': '« agit seul »',
  'auto.format': 'Format du résultat',
  'auto.format.text': 'Texte',
  'auto.format.json': 'JSON',
  'auto.formatHelp.text': 'Un livrable rédigé (Markdown).',
  'auto.formatHelp.json': 'Un objet JSON, utile quand n8n ou un autre outil lit le résultat.',
  'auto.badge.json': 'JSON',
  'auto.badge.approve': 'JE VALIDE AVANT D’AGIR',
  'auto.badge.auto': 'AGIT SEUL',
  'auto.badge.inherit': 'COMME L’AGENT',
  'auto.engine': 'Moteur',
  'auto.engineDefault': 'Celui de l’agent',
  'auto.engine.claude': 'Claude',
  'auto.engine.codex': 'Codex (ChatGPT)',
  'auto.engine.openai-image': 'Images OpenAI',
  'auto.engine.gemini': 'Gemini',
  'auto.engine.kie': 'Kie.ai (vidéo)',
  'auto.engineHint.gemini': 'Gemini : analyse de vidéos et d’images ; pas d’outils.',
  'auto.engineHint.openai-image': 'Images OpenAI : une image par tâche, la demande sert de description ; pas d’outils.',
  'auto.engineHint.kie': 'Kie.ai (vidéo) : une vidéo par tâche à partir des fichiers joints (la première image par défaut) ; la demande sert de description (en anglais de préférence) ; options « Durée : 8 s », « Format : 9:16 », « Résolution : 720p », « Mode : références », « Modèle : … » ; pas d’outils.',
  'auto.model': 'Modèle',
  'auto.modelDefault': 'par défaut',
  'auto.advanced': 'Moteur & modèle',
  'auto.effort': 'Effort',
  'auto.effortDefault': 'par défaut',
  'auto.effort.low': 'faible',
  'auto.effort.medium': 'moyen',
  'auto.effort.high': 'élevé',
  'auto.effort.xhigh': 'très élevé',
  'auto.effort.max': 'maximal',
  'auto.agent': 'Agent',
  'auto.agentPick': 'Choisir un agent…',
  'auto.noAgents': 'Aucun agent dans un service que vous gérez.',
  'auto.counter': '{n} / {max}',
  'auto.copy': 'COPIER',
  'auto.copied': 'Copié dans le presse-papiers.',
  'auto.copyFailed': 'Copie impossible : sélectionnez le texte et copiez-le à la main.',
  'auto.saveError': 'Enregistrement impossible.',
  'auto.fixErrors': 'Corrigez les champs signalés.',

  // Routines list
  'auto.routines.new': 'NOUVELLE ROUTINE',
  'auto.routines.emptyTitle': 'Aucune routine',
  'auto.routines.emptyText': 'Une routine fait travailler un agent à heure fixe : le point du lundi, le tri du matin, les relances du vendredi.',
  'auto.routines.emptyReadOnly': 'Aucune routine sur les services que vous voyez.',
  'auto.routines.create': 'Créer une routine',
  'auto.routines.emptyAgent': 'Aucune routine pour {name}',
  'auto.routines.next': 'PROCHAIN',
  'auto.routines.last': 'DERNIER',
  'auto.routines.runs': 'PASSAGES',
  'auto.routines.paused': 'EN PAUSE',
  'auto.routines.late': 'EN RETARD',
  'auto.routines.lastIdle': 'rien à faire ({when})',
  'auto.routines.lastIdleTitle': 'Dernier passage : rien à faire ({when})',
  'auto.routines.lastBlocked': 'bloqué ({reason})',
  'auto.routines.lastBlockedTitle': 'Dernier passage : bloqué ({reason}) — {when}',
  'auto.routines.lastBlockedNoReason': 'cause non précisée',
  'auto.routines.skipped': 'Passage sauté : le précédent est encore en cours ({when})',
  'auto.routines.skippedTitle': 'Aucune nouvelle tâche tant que la précédente n’est pas terminée ; le planning continue.',
  'auto.routines.activeLabel': 'Active',
  'auto.routines.toggleAria': 'Routine « {title} » active',
  'auto.routines.run': 'LANCER',
  'auto.routines.runTitle': 'Lancer maintenant, hors planning',
  'auto.routines.ran': 'Routine lancée.',
  'auto.routines.openTask': 'Ouvrir la tâche',
  'auto.routines.lastTaskAria': 'Ouvrir la dernière tâche de « {title} »',
  'auto.routines.edit': 'Modifier',
  'auto.routines.delete': 'Supprimer',
  'auto.routines.deleteTitle': 'Supprimer la routine ?',
  'auto.routines.deleteText': '« {title} » ne sera plus lancée. Les tâches déjà faites sont conservées.',
  'auto.routines.deleted': 'Routine supprimée.',
  'auto.routines.pausedToast': 'Routine mise en pause.',
  'auto.routines.resumedToast': 'Routine réactivée.',
  'auto.routines.count': { one: '{n} routine', other: '{n} routines' },
  'auto.routines.runsCount': { one: '{n} passage', other: '{n} passages' },

  // Routine editor
  'auto.re.titleNew': 'Nouvelle routine',
  'auto.re.titleEdit': 'Modifier la routine',
  'auto.re.agentLocked': 'La routine est créée pour cet agent.',
  'auto.re.phrase': 'En une phrase',
  'auto.re.phrasePlaceholder': 'tous les lundis à 9h, prépare le point de la semaine',
  'auto.re.phraseHint': 'Écrivez le rythme en français : le planning se remplit tout seul, la suite devient la consigne.',
  'auto.re.phraseFill': 'REMPLIR',
  'auto.re.phraseReading': 'Lecture de la phrase…',
  'auto.re.phraseOk': 'Compris : {description}.',
  'auto.re.phraseMissingDay': 'Compris en partie : précisez le jour.',
  'auto.re.phraseMissingTime': 'Compris en partie : précisez l’heure.',
  'auto.re.phraseInvalid': 'Rythme non reconnu. Essayez « chaque lundi à 9h30 » ou « toutes les 2 heures en semaine ».',
  'auto.re.phraseUnavailable': 'La lecture des phrases n’est pas disponible sur ce serveur : réglez le planning ci-dessous.',
  'auto.re.title': 'Titre',
  'auto.re.titlePlaceholder': 'Point hebdo des ventes',
  'auto.re.prompt': 'Consigne',
  'auto.re.promptPlaceholder': 'Ce que l’agent doit faire à chaque passage…',
  'auto.re.when': 'QUAND',
  'auto.re.kind': 'Rythme',
  'auto.re.kind.daily': 'Tous les jours',
  'auto.re.kind.weekdays': 'Jours ouvrés (lun. – ven.)',
  'auto.re.kind.weekly': 'Certains jours de la semaine',
  'auto.re.kind.monthly': 'Une fois par mois',
  'auto.re.kind.hourly': 'Toutes les N heures',
  'auto.re.kind.interval': 'Toutes les N minutes',
  'auto.re.at': 'Heure',
  'auto.re.days': 'Jours',
  'auto.re.dayOfMonth': 'Jour du mois',
  'auto.re.dayOfMonthHint': 'Les mois plus courts, le dernier jour du mois.',
  'auto.re.everyHours': 'Toutes les (heures)',
  'auto.re.everyMinutes': 'Toutes les (minutes)',
  'auto.re.everyMinutesHint': '5 minutes au moins ; chaque passage lance l’agent.',
  'auto.re.from': 'De',
  'auto.re.to': 'À',
  'auto.re.windowHint': 'Facultatif : limitez à une plage horaire.',
  'auto.re.weekdaysOnly': 'En semaine seulement',
  'auto.re.start': 'À partir du',
  'auto.re.end': 'Jusqu’au',
  'auto.re.preview': 'Routine · {description}',
  'auto.re.previewNext': 'prochain passage {when}',
  'auto.re.previewEnded': 'aucun passage à venir',
  'auto.re.active': 'Routine active',
  'auto.re.activeHint': 'En pause, elle reste au planning sans jamais se lancer.',
  'auto.re.save': 'ENREGISTRER',
  'auto.re.create': 'CRÉER LA ROUTINE',
  'auto.re.created': 'Routine créée : {description}.',
  'auto.re.saved': 'Routine enregistrée.',
  'auto.re.delete': 'Supprimer',

  // Triggers list
  'auto.triggers.new': 'NOUVEAU DÉCLENCHEUR',
  'auto.triggers.intro': 'n8n appelle le bureau à l’adresse du déclencheur, avec son secret ; l’agent reçoit la consigne remplie avec le JSON envoyé, et le résultat peut repartir vers n8n (rappel).',
  'auto.triggers.emptyTitle': 'Aucun déclencheur',
  'auto.triggers.emptyText': 'Un déclencheur laisse n8n confier une tâche à un agent : nouveau message client, pub analysée, images à créer…',
  'auto.triggers.emptyReadOnly': 'Les déclencheurs n8n d’un service ne se voient qu’avec le niveau « Gérer » sur ce service.',
  'auto.triggers.create': 'Créer un déclencheur',
  'auto.triggers.fires': 'APPELS',
  'auto.triggers.lastFired': 'DERNIER APPEL',
  'auto.triggers.secret': 'SECRET',
  'auto.triggers.noSecret': 'à créer',
  'auto.triggers.callback': 'RAPPEL',
  'auto.triggers.noCallback': 'aucun',
  'auto.triggers.disabled': 'DÉSACTIVÉ',
  'auto.triggers.enabledLabel': 'Activé',
  'auto.triggers.toggleAria': 'Déclencheur « {name} » activé',
  'auto.triggers.enabledToast': 'Déclencheur activé.',
  'auto.triggers.disabledToast': 'Déclencheur désactivé.',
  'auto.triggers.test': 'TESTER',
  'auto.triggers.integrate': 'INTÉGRER DANS N8N',
  'auto.triggers.edit': 'Modifier',
  'auto.triggers.rotate': 'Changer le secret',
  'auto.triggers.rotateTitle': 'Changer le secret ?',
  'auto.triggers.rotateText': 'L’ancien secret cesse de fonctionner tout de suite : les appels de n8n échoueront (401) tant que vous n’aurez pas mis le nouveau dans son identifiant Header Auth.',
  'auto.triggers.rotateConfirm': 'Changer le secret',
  'auto.triggers.delete': 'Supprimer',
  'auto.triggers.deleteTitle': 'Supprimer le déclencheur ?',
  'auto.triggers.deleteText': '« {name} » ne répondra plus : les appels de n8n seront refusés (401). Les tâches déjà créées sont conservées.',
  'auto.triggers.deleted': 'Déclencheur supprimé.',
  'auto.triggers.count': { one: '{n} déclencheur', other: '{n} déclencheurs' },

  // Trigger editor
  'auto.te.titleNew': 'Nouveau déclencheur n8n',
  'auto.te.titleEdit': 'Modifier le déclencheur',
  'auto.te.name': 'Nom',
  'auto.te.namePlaceholder': 'Crisp — nouveau message client',
  'auto.te.enabled': 'Activé',
  'auto.te.enabledHint': 'Désactivé, il refuse les appels de n8n (401).',
  'auto.te.template': 'Consigne donnée à l’agent',
  'auto.te.templatePlaceholder': 'Réponds au message de {{payload.nickname}} : {{payload.message}}',
  'auto.te.templateHint': 'Les repères {{payload.chemin.du.champ}} sont remplacés par les valeurs du JSON envoyé par n8n (un champ absent devient vide). L’agent reçoit aussi tout le JSON comme données externes, qu’il ne suit jamais comme des ordres.',
  'auto.te.placeholders': 'Repères disponibles (cliquez pour insérer)',
  'auto.te.placeholdersEmpty': 'Écrivez un exemple de JSON ci-dessous pour voir les repères.',
  'auto.te.now': 'date et heure de l’appel',
  'auto.te.sample': 'Exemple de JSON envoyé par n8n',
  'auto.te.sampleHint': 'Sert à l’aperçu et au bouton TESTER. Il reste dans ce navigateur.',
  'auto.te.sampleFromTemplate': 'Générer depuis la consigne',
  'auto.te.preview': 'Aperçu de la consigne reçue par l’agent',
  'auto.te.previewEmpty': 'La consigne apparaîtra ici.',
  'auto.te.missing': { one: 'Vide avec cet exemple : {list}', other: 'Vides avec cet exemple : {list}' },
  'auto.te.jsonExample': 'Exemple du JSON attendu en retour',
  'auto.te.jsonExampleHint': 'L’agent doit répondre avec un objet de cette forme. n8n le reçoit dans « output » du rappel.',
  'auto.te.jsonExamplePlaceholder': '{ "reply": "…", "tone": "amical" }',
  'auto.te.callback': 'RAPPEL VERS N8N',
  'auto.te.callbackIntro': 'Facultatif. Quand la tâche est terminée (après votre validation si elle en demande une), le bureau envoie le résultat à cette adresse.',
  'auto.te.callbackUrl': 'Adresse du webhook n8n',
  'auto.te.callbackUrlPlaceholder': 'http://127.0.0.1:5678/webhook/office-vers-crisp',
  'auto.te.callbackUrlHint': 'Elle doit commencer par une adresse autorisée par le serveur (n8n.callbackAllowlist), par exemple http://127.0.0.1:5678/.',
  'auto.te.callbackSecret': 'Secret de rappel',
  'auto.te.callbackSecretHint': 'Signe chaque rappel (en-tête X-Office-Signature, HMAC-SHA256) ; n8n le vérifie.',
  'auto.te.callbackSecretKeep': 'Laissez vide pour garder le secret de rappel actuel.',
  'auto.te.callbackSecretSet': 'Un secret de rappel est enregistré.',
  'auto.te.callbackSecretClear': 'Retirer le secret de rappel (rappels non signés)',
  'auto.te.show': 'Afficher',
  'auto.te.hide': 'Masquer',
  'auto.te.save': 'ENREGISTRER',
  'auto.te.create': 'CRÉER LE DÉCLENCHEUR',
  'auto.te.saved': 'Déclencheur enregistré.',
  'auto.te.created': 'Déclencheur créé.',

  // Secret shown once
  'auto.secret.title': 'Secret du déclencheur',
  'auto.secret.titleRotated': 'Nouveau secret',
  'auto.secret.warning': 'Copiez ce secret maintenant : il ne sera plus jamais affiché. Si vous le perdez, changez-le.',
  'auto.secret.where': 'Rangez-le dans n8n dans un identifiant (credential) Header Auth — Name : Authorization · Value : Bearer suivi du secret — jamais dans un champ texte d’un nœud.',
  'auto.secret.label': 'Secret',
  'auto.secret.copyBearer': 'COPIER « BEARER … »',
  'auto.secret.done': 'J’AI COPIÉ LE SECRET',
  'auto.secret.aria': 'Secret du déclencheur, affiché une seule fois',

  // Integration
  'auto.int.title': 'Intégrer dans n8n',
  'auto.int.url': 'Adresse à appeler (n8n et le bureau sont sur le Mac mini)',
  'auto.int.node': 'Nœud « HTTP Request » de n8n',
  'auto.int.body': 'Corps JSON (exemple)',
  'auto.int.curl': 'Essai depuis le Terminal du Mac mini',
  'auto.int.answers': 'Réponses : 202 {taskId, state} tout de suite ; avec ?wait= et un déclencheur autonome, 200 avec le résultat. Mauvais secret, déclencheur inconnu ou désactivé → 401 ; plus de 60 appels par minute → 429.',
  'auto.int.waitNote': 'Déclencheur autonome : ?wait=60 fait attendre le résultat (jusqu’à 120 s).',
  'auto.int.docker': 'n8n dans Docker : remplacez 127.0.0.1 par host.docker.internal.',
  'auto.int.files': 'Fichiers d’entrée (vidéo, images, PDF, audio)',
  'auto.int.filesHint': 'n8n dépose les fichiers ici et envoie leurs noms dans "files". Concrètement : un nœud « Write Binary File » écrit le fichier dans cette boîte de dépôt, puis le corps JSON le nomme : "files": ["video.mp4"] (10 fichiers au plus, 200 Mo chacun). Le bureau le déplace dans la tâche ; l’agent le lit (Gemini l’analyse directement).',
  'auto.int.inbox': 'Boîte de dépôt sur le Mac mini',
  'auto.int.inboxHint': 'n8n dépose les fichiers ici et envoie leurs noms dans "files".',

  // Test
  'auto.test.title': 'Tester « {name} »',
  'auto.test.intro': 'Crée une vraie tâche, comme si n8n avait appelé le déclencheur avec ce JSON.',
  'auto.test.payload': 'JSON envoyé',
  'auto.test.send': 'ENVOYER LE TEST',
  'auto.test.sent': 'Tâche de test créée.',
  'auto.test.openTask': 'OUVRIR LA TÂCHE',
  'auto.test.result': 'Tâche de test créée : ouvrez-la pour suivre le travail de l’agent.',
  'auto.test.disabledNote': 'Ce déclencheur est désactivé : le test passe quand même, mais les appels de n8n sont refusés (401).',
});
